var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg_({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "239.89453pt",
    height: "599.17578pt",
    viewBox: "0 0 239.89453 599.17578",
    id: "svg312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.703125,4.53125 C 3.578125,4.8125 3.273438,4.953125 2.796875,4.953125 2.660156,4.953125 2.53125,4.9375 2.40625,4.90625 L 1.71875,4.734375 C 0.957031,4.523438 0.445312,4.117188 0.1875,3.515625 0.0625,3.222656 0,2.878906 0,2.484375 V 1.15625 C 0,0.925781 0.113281,0.8125 0.34375,0.8125 c 0.226562,0 0.34375,0.113281 0.34375,0.34375 V 2.671875 C 0.6875,2.960938 0.785156,3.238281 0.984375,3.5 1.179688,3.769531 1.425781,3.941406 1.71875,4.015625 l 0.6875,0.1875 C 2.539062,4.234375 2.671875,4.25 2.796875,4.25 3.222656,4.25 3.4375,3.96875 3.4375,3.40625 v -0.625 c 0,-0.230469 0.113281,-0.34375 0.34375,-0.34375 0.226562,0 0.34375,0.113281 0.34375,0.34375 v 0.8125 c 0,0.414062 0.164062,0.769531 0.5,1.0625 0.15625,0.132812 0.328125,0.226562 0.515625,0.28125 0.125,0.019531 0.226563,0.03125 0.3125,0.03125 0.476563,0 0.71875,-0.277344 0.71875,-0.828125 V 2.8125 c 0,-0.230469 0.113281,-0.34375 0.34375,-0.34375 0.226563,0 0.34375,0.113281 0.34375,0.34375 v 1.515625 c 0,0.53125 -0.242187,0.925781 -0.71875,1.1875 C 5.929688,5.628906 5.707031,5.6875 5.46875,5.6875 5.363281,5.6875 5.253906,5.671875 5.140625,5.640625 4.398438,5.441406 3.921875,5.070312 3.703125,4.53125 Z m 0,0",
    id: "path1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.6875,2.65625 c 0,0.71875 0.34375,1.171875 1.03125,1.359375 l 0.6875,0.1875 C 2.539062,4.234375 2.664062,4.25 2.78125,4.25 3.21875,4.25 3.4375,3.96875 3.4375,3.40625 V 2.328125 L 1.71875,1.875 C 1.613281,1.84375 1.53125,1.828125 1.46875,1.828125 1.226562,1.828125 1.035156,1.90625 0.890625,2.0625 0.753906,2.226562 0.6875,2.425781 0.6875,2.65625 Z M 0,2.484375 c 0,-0.492187 0.25,-0.875 0.75,-1.15625 0.226562,-0.125 0.457031,-0.1875 0.6875,-0.1875 0.09375,0 0.179688,0.00781 0.265625,0.03125 L 3.78125,1.71875 C 4.539062,1.925781 5.175781,2.269531 5.6875,2.75 c 0.570312,0.539062 0.960938,1.238281 1.171875,2.09375 0,0.03125 0,0.0625 0,0.09375 0,0.226562 -0.117187,0.34375 -0.34375,0.34375 -0.1875,0 -0.292969,-0.078125 -0.3125,-0.234375 C 6.148438,4.671875 6.003906,4.289062 5.765625,3.90625 5.335938,3.207031 4.789062,2.757812 4.125,2.5625 V 3.59375 C 4.125,3.988281 4,4.3125 3.75,4.5625 3.5,4.820312 3.175781,4.953125 2.78125,4.953125 2.644531,4.953125 2.519531,4.9375 2.40625,4.90625 L 1.71875,4.71875 C 0.914062,4.5 0.398438,4.113281 0.171875,3.5625 0.0546875,3.269531 0,2.910156 0,2.484375 Z m 0,0",
    id: "path2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.390625,4.84375 0.15625,2.875 C 0.0507812,2.800781 0,2.703125 0,2.578125 c 0,-0.09375 0.0351562,-0.179687 0.109375,-0.25 0.070313,-0.0625 0.15625,-0.09375 0.25,-0.09375 L 6.53125,2.46875 c 0.21875,0 0.328125,0.113281 0.328125,0.34375 0,0.238281 -0.121094,0.351562 -0.359375,0.34375 L 1.625,2.953125 4.640625,4.8125 C 4.753906,4.875 4.8125,4.96875 4.8125,5.09375 c 0,0.21875 -0.109375,0.335938 -0.328125,0.359375 l -2.90625,0.21875 5.09375,2.515625 c 0.125,0.0625 0.1875,0.164062 0.1875,0.3125 0,0.226562 -0.109375,0.34375 -0.328125,0.34375 -0.0625,0 -0.117188,-0.011719 -0.15625,-0.03125 L 0.1875,5.734375 C 0.0625,5.671875 0,5.570312 0,5.4375 0,5.21875 0.101562,5.097656 0.3125,5.078125 Z m 0,0",
    id: "path3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.6875,4 c 0,0.226562 -0.117188,0.34375 -0.34375,0.34375 C 0.113281,4.34375 0,4.226562 0,4 V 1.0625 C 0,0.96875 0.03125,0.894531 0.09375,0.84375 0.164062,0.789062 0.25,0.773438 0.34375,0.796875 l 6.265625,1.6875 c 0.164063,0.039063 0.25,0.148437 0.25,0.328125 0,0.226562 -0.109375,0.34375 -0.328125,0.34375 -0.042969,0 -0.078125,-0.00781 -0.109375,-0.015625 L 0.6875,1.609375 Z m 0,0",
    id: "path4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3.4375,4.21875 v -1.875 L 0.6875,1.609375 V 4 c 0,0.226562 -0.117188,0.34375 -0.34375,0.34375 C 0.113281,4.34375 0,4.226562 0,4 V 1.0625 C 0,0.96875 0.03125,0.894531 0.09375,0.84375 0.164062,0.789062 0.25,0.773438 0.34375,0.796875 l 6.171875,1.65625 c 0.226563,0.0625 0.34375,0.210937 0.34375,0.453125 v 2.75 C 6.859375,5.882812 6.742188,6 6.515625,6 6.285156,6 6.171875,5.882812 6.171875,5.65625 V 3.078125 L 4.125,2.53125 v 1.6875 C 4.125,4.445312 4.007812,4.5625 3.78125,4.5625 3.550781,4.5625 3.4375,4.445312 3.4375,4.21875 Z m 0,0",
    id: "path5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 6.515625,2.453125 c 0.226563,0.0625 0.34375,0.210937 0.34375,0.453125 v 2.140625 c 0,0.351563 -0.152344,0.664063 -0.453125,0.9375 -0.304688,0.269531 -0.632812,0.40625 -0.984375,0.40625 -0.09375,0 -0.1875,-0.011719 -0.28125,-0.03125 L 1.71875,5.4375 C 0.570312,5.125 0,4.378906 0,3.203125 V 1.0625 C 0,0.96875 0.03125,0.894531 0.09375,0.84375 0.164062,0.789062 0.25,0.773438 0.34375,0.796875 Z m -0.34375,0.625 L 0.6875,1.609375 V 3.375 c 0,0.300781 0.097656,0.582031 0.296875,0.84375 0.195313,0.257812 0.441406,0.429688 0.734375,0.515625 l 3.421875,0.90625 C 5.234375,5.671875 5.320312,5.6875 5.40625,5.6875 c 0.226562,0 0.410156,-0.085938 0.546875,-0.25 0.144531,-0.15625 0.21875,-0.351562 0.21875,-0.578125 z m 0,0",
    id: "path6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.234375,1.9375 C 4.378906,1.53125 4.585938,1.226562 4.859375,1.03125 5.128906,0.84375 5.453125,0.75 5.828125,0.75 c 0.570313,0 1.050781,0.203125 1.4375,0.609375 C 7.648438,1.773438 7.84375,2.320312 7.84375,3 7.84375,3.6875 7.644531,4.238281 7.25,4.65625 6.851562,5.070312 6.375,5.28125 5.8125,5.28125 5.445312,5.28125 5.128906,5.179688 4.859375,4.984375 4.585938,4.796875 4.378906,4.507812 4.234375,4.125 4.078125,4.601562 3.820312,4.96875 3.46875,5.21875 c -0.34375,0.25 -0.757812,0.375 -1.234375,0.375 -0.667969,0 -1.230469,-0.242188 -1.6875,-0.71875 -0.4609375,-0.46875 -0.6875,-1.089844 -0.6875,-1.859375 0,-0.773437 0.2265625,-1.398437 0.6875,-1.875 C 1.003906,0.671875 1.578125,0.4375 2.265625,0.4375 2.773438,0.4375 3.195312,0.566406 3.53125,0.828125 3.875,1.085938 4.109375,1.457031 4.234375,1.9375 Z m 1.625,-0.203125 c -0.367187,0 -0.667969,0.117187 -0.90625,0.359375 -0.230469,0.238281 -0.34375,0.550781 -0.34375,0.9375 0,0.363281 0.113281,0.660156 0.34375,0.890625 C 5.191406,4.160156 5.476562,4.28125 5.8125,4.28125 6.164062,4.28125 6.460938,4.160156 6.703125,3.921875 6.941406,3.679688 7.0625,3.378906 7.0625,3.015625 7.0625,2.648438 6.941406,2.34375 6.703125,2.09375 6.472656,1.851562 6.191406,1.734375 5.859375,1.734375 Z M 2.25,1.421875 c -0.273438,0 -0.539062,0.0625 -0.796875,0.1875 -0.25,0.132813 -0.449219,0.332031 -0.59375,0.59375 C 0.722656,2.460938 0.65625,2.738281 0.65625,3.03125 c 0,0.457031 0.144531,0.832031 0.4375,1.125 0.300781,0.300781 0.675781,0.453125 1.125,0.453125 0.46875,0 0.851562,-0.15625 1.15625,-0.46875 C 3.675781,3.835938 3.828125,3.457031 3.828125,3 3.828125,2.539062 3.675781,2.160156 3.375,1.859375 3.070312,1.566406 2.695312,1.421875 2.25,1.421875 Z m 0,0",
    id: "path7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3.859375,0.453125 c 0.925781,0 1.671875,0.09375 2.234375,0.28125 C 6.65625,0.929688 7.085938,1.21875 7.390625,1.59375 7.691406,1.96875 7.84375,2.4375 7.84375,3 c 0,0.414062 -0.085938,0.78125 -0.25,1.09375 C 7.425781,4.414062 7.179688,4.679688 6.859375,4.890625 6.546875,5.097656 6.160156,5.257812 5.703125,5.375 5.242188,5.488281 4.628906,5.546875 3.859375,5.546875 c -0.917969,0 -1.65625,-0.09375 -2.21875,-0.28125 -0.5625,-0.1875 -1,-0.46875 -1.3125,-0.84375 -0.3125,-0.375 -0.46875,-0.851563 -0.46875,-1.421875 0,-0.75 0.269531,-1.339844 0.8125,-1.765625 0.65625,-0.523437 1.71875,-0.78125 3.1875,-0.78125 z m 0,0.984375 c -1.28125,0 -2.136719,0.148438 -2.5625,0.453125 C 0.867188,2.191406 0.65625,2.5625 0.65625,3 c 0,0.4375 0.210938,0.804688 0.640625,1.109375 0.425781,0.300781 1.28125,0.453125 2.5625,0.453125 1.28125,0 2.132813,-0.152344 2.5625,-0.453125 C 6.847656,3.804688 7.0625,3.429688 7.0625,2.984375 7.0625,2.546875 6.875,2.195312 6.5,1.9375 6.019531,1.601562 5.140625,1.4375 3.859375,1.4375 Z m 0,0",
    id: "path8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0.796875 h 7.8125 v 1.03125 H 0.921875 V 5.6875 H 0 Z m 0,0",
    id: "path9"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 169.5039,-111.76953 v -65.64063 m 1.68359,65.64063 v -65.64063 m 1.67969,65.64063 v -65.64063 m 1.79688,65.64063 v -65.64063 m 1.67968,65.64063 v -65.64063 m 1.6836,12.11719 h -10.32031 m 10.32031,41.40234 h -10.32031 m 72,722.87891 h -41.88282 m -6.23828,0 h -6.24219 m -6.23828,0 h -6.23828 m -6.24218,0 h -31.07813 m -6.24219,0 h -6.23828 m -6.24219,0 h -6.23828 m -6.24219,0 H 73.14453 m -6.238282,0 h -6.24219 m -6.238283,0 H 48.30468",
    id: "path28"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g316",
    transform: "translate(-181.73437,-216.53125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g315"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 298.40104,1087.3594 H 242.5625 v -46.0781",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-0.00162233 V -8.319331 m 0,-8.322916 v -8.15625 m 0,-8.322917 v -41.598958 m 0,-8.317709 v -8.322916 m 0,-8.317709 v -8.322914 m 0,-8.31771 v -41.44271 m 0,-8.31771 v -8.31771 m 0,-8.32291 v -8.31771 m 0,-8.32292 v -41.59896 m 0,-8.3177 v -8.32292 m 0,-8.31771 v -8.32292 m 0,-8.15625 v -41.60416 m 0,-8.31771 v -8.32292 m 0,-8.31771 v -8.3177 m 0,-8.32292 v -41.59896 m 0,-8.16146 v -8.31771 m 0,-8.32291 v -8.31771 m 0,-8.32292 v -41.59896 m 0,-8.3177 v -8.32292 m 0,-8.31771 v -8.32292 m 0,-8.3177 v -41.4375 m 0,-8.32292 v -8.31771 m 0,-8.32292 v -8.3177 m 0,-8.32292 v -41.59896 m 0,-8.16146 v -8.31771 m 0,-8.3177 v -8.32292",
    transform: "matrix(0.75,0,0,0.75,181.92,774.71997)",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 242.5625,335.04167 v -46.08333 h 55.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.001251,-0.00165233 h 8.161458 m 8.317709,0 h 8.322916 m 8.317709,0 h 41.598958 m 8.322917,0 h 8.317708 m 8.322917,0 h 8.317709 m 8.32292,0 h 41.4375 m 8.32291,0 h 8.31771 m 8.31771,0 h 8.32292",
    transform: "matrix(0.75,0,0,0.75,230.04,216.71999)",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 506.07812,288.95834 h 55.84375 v 46.08333",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001892,-6.04667e-4 V 8.322312 m 0,8.317708 v 8.317709 m 0,8.161458 v 41.598958 m 0,8.322917 v 8.317708 m 0,8.322917 v 8.317713 m 0,8.32291 v 41.4375 m 0,8.31771 v 8.32292 m 0,8.3177 v 8.32292 m 0,8.31771 v 41.59896 m 0,8.32291 v 8.31771 m 0,8.32292 v 8.31771 m 0,8.16146 v 41.59895 m 0,8.32292 v 8.31771 m 0,8.31771 v 8.32291 m 0,8.31771 v 41.60417 m 0,8.15625 v 8.32292 m 0,8.3177 v 8.32292 m 0,8.31771 v 41.59896 m 0,8.32291 v 8.31771 m 0,8.32292 v 8.31771 m 0,8.31771 v 41.44271 m 0,8.3177 v 8.32292 m 0,8.31771 v 8.32292 m 0,8.3177 v 41.59896 m 0,8.32292 v 8.15625 m 0,8.32292 v 8.3177",
    transform: "matrix(0.75,0,0,0.75,421.43999,257.51999)",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 561.92187,1041.2813 v 46.0781",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 421.44141,216.71875 -0.36329,17.76172 v -17.76172 z m 0,0",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 421.44141,216.71875 v 17.76172 h -0.36329 z m 0,0",
    id: "path37"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 421.07812,234.12109 -2.63671,0.35938 v -0.35938 z m 0,0",
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 421.07812,234.12109 v 0.35938 h -2.63671 z m 0,0",
    id: "path39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 418.44141,231.83984 -0.24219,2.64063 v -2.64063 z m 0,0",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 418.44141,231.83984 v 2.64063 h -0.24219 z m 0,0",
    id: "path41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 409.19922,219.71875 -2.16016,0.24219 v -0.24219 z m 0,0",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 409.19922,219.71875 v 0.24219 h -2.16016 z m 0,0",
    id: "path43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 421.07812,216.71875 -14.03906,0.35937 v -0.35937 z m 0,0",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 421.07812,216.71875 v 0.35937 h -14.03906 z m 0,0",
    id: "path45"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 407.03906,216.71875 -0.35937,3.24219 v -3.24219 z m 0,0",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 407.03906,216.71875 v 3.24219 h -0.35937 z m 0,0",
    id: "path47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-0.00165233 H 19.681885 M 0.47876,0.477514 h 18.71875 m 0.484375,-0.47916633 V 23.680639 M 19.19751,0.477514 v 22.723959 m 0.484375,0.479166 h -4.322917 m 3.838542,-0.479166 h -3.515625 m -0.322917,0.479166 v -3.520833 m 0.322917,3.041667 V 20.159806 M -4.06667e-4,-0.00165233 V 4.321264 M 0.47876,0.477514 V 3.998348 M -4.06667e-4,4.321264 H 3.358968",
    transform: "matrix(0.75,0,0,0.75,406.67999,216.71999)",
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 542.71875,292.95834 h 2.88021 v 0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001892,-1.98e-4 H -0.321025 M -5.1179,-15.83874 v 1.4375 m 0,0.479167 v 1.604167 m 0,0.317708 v 1.598958 m 0,0.322917 v 1.598958 m 0,0.479167 v 1.598958 m 0,0.322917 v 1.598958",
    transform: "matrix(0.75,0,0,0.75,418.43999,231.83999)",
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,304.95834 v 1.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.13333e-4,0.00125633 H 1.441895 m 0.317708,0 h 1.598959 m 0.479166,0 h 1.604167 m 0.317708,0 h 1.598959 m 0.322916,0 h 1.598959 m 0.479166,0 h 1.442709",
    transform: "matrix(0.75,0,0,0.75,408.35998,231.95999)",
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.16146,309.28125 h 1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 181.92187,216.71875 0.23829,17.76172 v -17.76172 z m 0,0",
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 181.92187,216.71875 v 17.76172 h 0.23829 z m 0,0",
    id: "path55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 182.16016,234.12109 2.64062,0.35938 v -0.35938 z m 0,0",
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 182.16016,234.12109 v 0.35938 h 2.64062 z m 0,0",
    id: "path57"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 184.80078,231.83984 0.35938,2.64063 v -2.64063 z m 0,0",
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 184.80078,231.83984 v 2.64063 h 0.35938 z m 0,0",
    id: "path59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 194.03906,219.71875 2.28125,0.24219 v -0.24219 z m 0,0",
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 194.03906,219.71875 v 0.24219 h 2.28125 z m 0,0",
    id: "path61"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 182.16016,216.71875 14.16015,0.35937 v -0.35937 z m 0,0",
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 182.16016,216.71875 v 0.35937 h 14.16015 z m 0,0",
    id: "path63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 196.32031,216.71875 0.35938,3.24219 v -3.24219 z m 0,0",
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 196.32031,216.71875 v 3.24219 h 0.35938 z m 0,0",
    id: "path65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-0.00165233 H -19.67749 M -0.479573,0.477514 H -19.359782 M -19.67749,-0.00165233 V 23.680639 m 0.317708,-23.203125 v 22.723959 m -0.317708,0.479166 h 4.317708 m -4,-0.479166 h 3.520834 m 0.479166,0.479166 v -3.520833 m -0.479166,3.041667 V 20.159806 M -4.06667e-4,-0.00165233 V 4.321264 M -0.479573,0.477514 V 3.998348 M -4.06667e-4,4.321264 H -3.52124",
    transform: "matrix(0.75,0,0,0.75,196.67999,216.71999)",
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 261.76042,292.95834 h -3.04167 v 0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00104767,-1.98e-4 H 0.480214 M 5.282298,-15.83874 v 1.4375 m 0,0.479167 v 1.604167 m 0,0.317708 v 1.598958 m 0,0.322917 v 1.598958 m 0,0.479167 v 1.598958 m 0,0.322917 v 1.598958",
    transform: "matrix(0.75,0,0,0.75,184.8,231.83999)",
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 251.68229,304.95834 v 1.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0,0.00125633 h -1.4375 m -0.484375,0 h -1.598958 m -0.317709,0 H -5.4375 m -0.322917,0 h -1.598958 m -0.479167,0 H -9.28125 m -0.479167,0 h -1.598958",
    transform: "matrix(0.75,0,0,0.75,195,231.95999)",
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 248.31771,309.28125 h -1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path71"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 421.44141,815.51953 -0.36329,-17.75781 v 17.75781 z m 0,0",
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 421.44141,815.51953 v -17.75781 h -0.36329 z m 0,0",
    id: "path73"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 421.07812,798.12109 -2.63671,-0.35937 v 0.35937 z m 0,0",
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 421.07812,798.12109 v -0.35937 h -2.63671 z m 0,0",
    id: "path75"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 418.44141,800.39844 -0.24219,-2.63672 v 2.63672 z m 0,0",
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 418.44141,800.39844 v -2.63672 h -0.24219 z m 0,0",
    id: "path77"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 409.19922,812.51953 -2.16016,-0.23828 v 0.23828 z m 0,0",
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 409.19922,812.51953 v -0.23828 h -2.16016 z m 0,0",
    id: "path79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 421.07812,815.51953 -14.03906,-0.35937 v 0.35937 z m 0,0",
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 421.07812,815.51953 v -0.35937 h -14.03906 z m 0,0",
    id: "path81"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 407.03906,815.51953 -0.35937,-3.23828 v 3.23828 z m 0,0",
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 407.03906,815.51953 v -3.23828 h -0.35937 z m 0,0",
    id: "path83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-6.04667e-4 H 19.681885 M 0.47876,-0.479771 h 18.71875 m 0.484375,0.479166333 V -23.677688 M 19.19751,-0.479771 v -22.71875 m 0.484375,-0.479167 h -4.322917 m 3.838542,0.479167 h -3.515625 m -0.322917,-0.479167 v 3.515625 m 0.322917,-3.036458 v 3.036458 M -4.06667e-4,-6.04667e-4 V -4.318313 M 0.47876,-0.479771 V -4.000605 M -4.06667e-4,-4.318313 H 3.358968",
    transform: "matrix(0.75,0,0,0.75,406.67999,815.51999)",
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 542.71875,1083.3594 h 2.88021 v -0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001892,-0.002029 H -0.321025 M -5.1179,15.841721 v -1.442708 m 0,-0.479167 v -1.598958 m 0,-0.322917 v -1.598958 m 0,-0.317709 V 8.482346 m 0,-0.484375 V 6.399013 m 0,-0.317709 V 4.482346",
    transform: "matrix(0.75,0,0,0.75,418.43999,800.39996)",
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,1071.3594 v -1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.13333e-4,0.001633 H 1.441895 m 0.317708,0 h 1.598959 m 0.479166,0 h 1.604167 m 0.317708,0 h 1.598959 m 0.322916,0 h 1.598959 m 0.479166,0 h 1.442709",
    transform: "matrix(0.75,0,0,0.75,408.35998,800.28003)",
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.16146,1067.0417 h 1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path89"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 181.92187,815.51953 0.23829,-17.75781 v 17.75781 z m 0,0",
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 181.92187,815.51953 v -17.75781 h 0.23829 z m 0,0",
    id: "path91"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 182.16016,798.12109 2.64062,-0.35937 v 0.35937 z m 0,0",
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 182.16016,798.12109 v -0.35937 h 2.64062 z m 0,0",
    id: "path93"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 184.80078,800.39844 0.35938,-2.63672 v 2.63672 z m 0,0",
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 184.80078,800.39844 v -2.63672 h 0.35938 z m 0,0",
    id: "path95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 194.03906,812.51953 2.28125,-0.23828 v 0.23828 z m 0,0",
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 194.03906,812.51953 v -0.23828 h 2.28125 z m 0,0",
    id: "path97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 182.16016,815.51953 14.16015,-0.35937 v 0.35937 z m 0,0",
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 182.16016,815.51953 v -0.35937 h 14.16015 z m 0,0",
    id: "path99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 196.32031,815.51953 0.35938,-3.23828 v 3.23828 z m 0,0",
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 196.32031,815.51953 v -3.23828 h 0.35938 z m 0,0",
    id: "path101"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-6.04667e-4 H -19.67749 M -0.479573,-0.479771 H -19.359782 M -19.67749,-6.04667e-4 V -23.677688 m 0.317708,23.197917 v -22.71875 m -0.317708,-0.479167 h 4.317708 m -4,0.479167 h 3.520834 m 0.479166,-0.479167 v 3.515625 m -0.479166,-3.036458 v 3.036458 M -4.06667e-4,-6.04667e-4 V -4.318313 M -0.479573,-0.479771 V -4.000605 M -4.06667e-4,-4.318313 H -3.52124",
    transform: "matrix(0.75,0,0,0.75,196.67999,815.51999)",
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 261.76042,1083.3594 h -3.04167 v -0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path103"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00104767,-0.002029 H 0.480214 m 4.802084,15.84375 v -1.442708 m 0,-0.479167 v -1.598958 m 0,-0.322917 v -1.598958 m 0,-0.317709 V 8.482346 m 0,-0.484375 V 6.399013 m 0,-0.317709 V 4.482346",
    transform: "matrix(0.75,0,0,0.75,184.8,800.39996)",
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 251.68229,1071.3594 v -1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path105"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0,0.001633 h -1.4375 m -0.484375,0 h -1.598958 m -0.317709,0 H -5.4375 m -0.322917,0 h -1.598958 m -0.479167,0 H -9.28125 m -0.479167,0 h -1.598958",
    transform: "matrix(0.75,0,0,0.75,195,800.28003)",
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 248.31771,1067.0417 h -1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path107"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 408,745.1198 v 157.11979 h -9.92188 V 745.1198 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00122633 -0.642079,-0.800857 l -0.958334,-0.796875 -0.958333,-0.484375 -1.119792,-0.317708 -1.119791,-0.161459 -1.119792,0.161459 -1.119792,0.317708 -0.963541,0.484375 -0.958334,0.796875 -0.640625,0.80208333",
    transform: "matrix(0.75,0,0,0.75,305.88,558.96002)",
    id: "path109"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-4.01333e-4 0.640218,0.801682 1.598552,1.598557 2.562093,2.077724 3.681885,2.40064 4.801677,2.562099 5.921468,2.40064 7.04126,2.077724 7.999593,1.598557 8.957927,0.801682 9.598552,-4.01333e-4",
    transform: "matrix(0.75,0,0,0.75,298.67999,676.67999)",
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 403.04167,745.1198 V 902.23959",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path111"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g111"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 308.03464,
    y: 595.55176,
    id: "use111"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 18452.707,-9586.048 c 8.649,3.8438 12.973,13.213 12.973,27.8675 0,4.2041 -0.481,8.168 -1.442,12.0118 l -5.285,21.1408 c -6.486,23.4231 -18.978,39.1586 -37.477,47.0864 -9.009,3.8438 -19.579,5.7657 -31.711,5.7657 h -40.84 c -7.087,0 -10.571,-3.4834 -10.571,-10.5704 0,-6.9669 3.484,-10.5704 10.571,-10.5704 h 46.606 c 8.889,0 17.417,-3.003 25.465,-9.129 8.288,-6.0059 13.573,-13.5734 15.855,-22.5823 l 5.766,-21.1408 c 0.961,-4.084 1.442,-8.1681 1.442,-12.0118 0,-13.0929 -8.649,-19.6995 -25.946,-19.6995 h -19.219 c -7.087,0 -10.57,-3.4834 -10.57,-10.5704 0,-6.9668 3.483,-10.5704 10.57,-10.5704 h 24.985 c 12.732,0 23.663,-5.045 32.672,-15.3751 4.084,-4.8048 6.967,-10.09 8.648,-15.8557 0.601,-3.8438 0.961,-6.9668 0.961,-9.6094 0,-14.6545 -8.528,-22.1018 -25.465,-22.1018 h -40.84 c -7.087,0 -10.57,-3.4835 -10.57,-10.5704 0,-6.9669 3.483,-10.5705 10.57,-10.5705 h 46.606 c 16.336,0 28.468,7.4474 36.516,22.1018 3.483,6.4864 5.285,13.3332 5.285,20.6604 0,3.2432 -0.48,6.6065 -1.441,10.0899 -6.126,22.8225 -17.538,37.477 -34.114,44.2036 z m 0,0",
    transform: "matrix(0,0.03252,-0.03252,0,0,-4e-6)",
    id: "path112"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g112"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 308.03464,
    y: 600.44775,
    id: "use112"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 18545.679,-9493.3166 c 22.102,0 36.035,-10.5704 41.801,-31.7113 l 5.766,-21.1408 c 0.961,-4.084 1.441,-7.9278 1.441,-11.5314 0,-13.4532 -8.648,-20.1799 -25.946,-20.1799 h -33.152 l -13.934,52.8521 c -0.961,3.2432 -1.441,5.7657 -1.441,7.6876 0,7.4473 2.402,13.3332 7.207,17.7775 5.045,4.2042 11.171,6.2462 18.258,6.2462 z m -5.285,21.1408 c -15.135,0 -26.907,-7.6876 -35.556,-23.0627 -3.843,-6.9669 -5.765,-14.0539 -5.765,-21.1408 0,-2.8829 0.24,-5.5255 0.961,-8.1681 l 16.816,-63.903 c 6.367,-23.3029 16.937,-42.8822 31.712,-58.6177 16.576,-17.5373 38.077,-29.5492 64.383,-36.0356 0.961,0 1.922,0 2.883,0 6.967,0 10.57,3.6036 10.57,10.5705 0,5.7656 -2.402,9.0088 -7.207,9.6094 -11.531,1.6817 -23.303,6.1261 -35.074,13.4533 -21.502,13.213 -35.315,30.0296 -41.321,50.4497 h 31.711 c 12.132,0 22.102,3.8438 29.79,11.5314 7.927,7.6875 12.011,17.6574 12.011,29.7893 0,4.2042 -0.48,8.048 -1.441,11.5314 l -5.766,21.1408 c -6.726,24.7444 -18.618,40.6 -35.555,47.5669 -9.009,3.6036 -20.06,5.2852 -33.152,5.2852 z m 0,0",
    transform: "matrix(0,0.03252,-0.03252,0,0,-4e-6)",
    id: "path113"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g113"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 308.03464,
    y: 605.34369,
    id: "use113"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 18763.453,-9576.4385 -60.539,99.458 c -2.283,3.2432 -5.285,4.8047 -9.129,4.8047 -2.883,0 -5.526,-1.081 -7.688,-3.3633 -1.922,-2.1621 -2.883,-4.8047 -2.883,-7.6876 l 7.207,-189.787 c 0,-6.7267 3.484,-10.09 10.571,-10.09 7.327,0 10.81,3.7237 10.57,11.0509 l -6.246,149.9078 57.176,-92.7314 c 1.922,-3.4835 4.805,-5.2852 8.649,-5.2852 6.727,0 10.33,3.3633 11.051,10.0899 l 6.726,89.3681 77.357,-156.6344 c 1.922,-3.8438 5.045,-5.7657 9.609,-5.7657 6.967,0 10.571,3.3633 10.571,10.09 0,1.9219 -0.361,3.6035 -0.961,4.8047 l -94.654,190.2675 c -1.922,3.8438 -5.045,5.7657 -9.129,5.7657 -6.726,0 -10.45,-3.1231 -11.051,-9.6094 z m 0,0",
    transform: "matrix(0,0.03252,-0.03252,0,0,-4e-6)",
    id: "path114"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g114"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 308.15952,
    y: 619.55475,
    id: "use114"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 19174.499,-9497.1604 c 6.966,0 10.57,3.6035 10.57,10.5704 0,7.087 -3.604,10.5704 -10.57,10.5704 h -90.33 c -2.882,0 -5.165,-0.9609 -6.726,-2.8828 -1.682,-2.1621 -2.162,-4.8047 -1.442,-7.6876 l 51.892,-192.6699 c 1.201,-5.045 4.564,-7.6876 10.09,-7.6876 6.966,0 10.57,3.3634 10.57,10.09 0,1.3213 -0.24,2.4024 -0.481,3.3633 l -47.086,176.3338 z m 0,0",
    transform: "matrix(0,0.03252,-0.03252,0,0,-4e-6)",
    id: "path115"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g115"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 308.15952,
    y: 624.45074,
    id: "use115"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 19331.733,-9581.7237 h -57.656 l -22.583,84.5633 h 73.513 c 6.967,0 10.57,3.6035 10.57,10.5704 0,7.087 -3.603,10.5704 -10.57,10.5704 h -90.329 c -2.883,0 -5.165,-0.9609 -6.727,-2.8828 -1.681,-2.1621 -2.162,-4.8047 -1.441,-7.6876 l 50.93,-189.787 c 1.922,-6.9669 6.486,-10.5705 13.934,-10.5705 h 84.563 c 6.967,0 10.57,3.6036 10.57,10.5705 0,7.0869 -3.603,10.5704 -10.57,10.5704 h -79.278 l -16.817,62.942 h 51.891 c 6.967,0 10.571,3.6036 10.571,10.5704 0,7.087 -3.604,10.5705 -10.571,10.5705 z m 0,0",
    transform: "matrix(0,0.03252,-0.03252,0,0,-4e-6)",
    id: "path116"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g116"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 308.15952,
    y: 629.25067,
    id: "use116"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 19425.065,-9676.377 c 1.922,-6.9669 6.487,-10.5705 13.934,-10.5705 h 65.825 c 10.811,0 20.42,4.6847 28.828,13.9338 8.289,9.3692 12.493,19.4592 12.493,30.2698 0,2.8829 -0.361,5.7657 -0.961,8.6485 l -28.348,105.2237 c -9.61,35.3148 -32.552,52.8521 -68.708,52.8521 h -65.825 c -2.883,0 -5.165,-0.9609 -6.726,-2.8828 -1.682,-2.1621 -2.162,-4.8047 -1.442,-7.6876 z m 19.219,10.5704 -45.164,168.6462 h 54.293 c 9.25,0 17.898,-3.003 25.946,-9.129 7.928,-6.0059 13.213,-13.5734 15.856,-22.5823 l 27.867,-105.2237 c 0.961,-2.8828 1.441,-5.5254 1.441,-8.168 0,-6.9669 -2.642,-12.6124 -7.687,-16.8166 -4.805,-4.4444 -10.811,-6.7266 -17.778,-6.7266 z m 0,0",
    transform: "matrix(0,0.03252,-0.03252,0,0,-4e-6)",
    id: "path117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 420.47917,826.23959 v 23.52083 h -10.07813 v -23.52083 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 474.71875,340.80209 v -8.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path119"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 474.71875,332.31771 0.80208,-0.63541 0.79688,-0.80209 0.64062,-0.80208 0.47917,-1.11979 0.16146,-0.95834 0.16146,-1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 477.92187,326.88021 V 313.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.00186733 -0.161052,-1.279383 -0.47876,-2.399174 -1.119385,-3.518966 -1.921468,-4.482508 -2.879802,-5.279383 -3.999593,-5.920008 -5.119385,-6.237716 -6.400635,-6.399174",
    transform: "matrix(0.75,0,0,0.75,358.32001,235.44001)",
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 471.35937,307.35938 H 432.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00145433,8.49667e-4 -1.279796,0.162308 -2.399587,0.480016 -3.519379,1.120641 -4.477712,1.917516 -5.279796,2.881058 -5.920421,4.00085 -6.238129,5.120641 -6.399587,6.401891",
    transform: "matrix(0.75,0,0,0.75,324.12,230.63999)",
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 425.59896,313.92188 v 12.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path125"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 425.76042,326.88021 0.16145,1.11979 0.15625,0.95834 0.48438,1.11979 0.63542,0.80208 0.80208,0.80209 0.80208,0.63541",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 428.80208,332.64063 v 8.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path127"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 428.95833,340.80209 -0.47916,1.59896 L 427.83854,344",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 427.83854,344.16146 426.88021,348 l -0.64063,3.83855 -0.31771,3.84375 -0.16145,4",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path129"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 425.76042,359.6823 0.16145,4 0.31771,3.83854 0.64063,3.83854 0.95833,3.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 427.83854,375.35938 1.11979,3.20312 1.28125,3.03646 1.44271,3.04167 1.75521,2.71875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path131"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 433.28125,387.35938 1.28125,1.76042 1.27604,1.59895 1.59896,1.59896 1.44271,1.28125 1.76041,1.44271 1.76042,1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 442.23958,396.16146 1.44271,0.79688 3.19792,1.28125 1.59896,0.32291 1.59895,0.31771 h 1.60417",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 451.68229,398.88021 h 1.59896 l 1.59896,-0.31771 1.59896,-0.32291 1.59895,-0.64063 1.60417,-0.64062 1.4375,-0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 461.11979,396.16146 1.76042,-1.11979 1.76041,-1.44271 1.4375,-1.28125 1.60417,-1.59896 1.27604,-1.59895 1.28125,-1.76042",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 470.07812,387.35938 1.76042,-2.71875 1.44271,-3.04167 1.28125,-3.03646 1.11979,-3.20312",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 475.68229,375.19792 0.95833,-3.83854 0.64063,-3.83854 0.31771,-3.83854 0.16146,-4",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 477.76042,359.6823 -0.16146,-4 -0.31771,-3.84375 -0.64063,-3.83855 -0.95833,-3.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 475.68229,344 -0.64062,-1.59895 -0.47917,-1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path139"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 440.16146,333.4375 -0.80209,1.125 -0.64062,0.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 438.71875,335.52084 -1.4375,2.40104 -1.28125,2.55729 -1.11979,2.5625 -0.80209,2.71875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 434.23958,345.76042 -0.80208,3.52083 -0.63542,3.35938 -0.32291,3.52083 -0.16146,3.52084",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 432.31771,359.6823 0.16146,3.51562 0.32291,3.52083 0.63542,3.35938 0.80208,3.52083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path143"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 434.07812,373.59896 0.80209,2.71875 1.11979,2.5625 1.28125,2.55729 1.4375,2.40105",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 438.71875,383.83855 1.44271,1.92187 1.59896,1.92188 1.92187,1.59895 2.07813,1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path145"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 445.76042,390.5625 1.4375,0.79688 1.4427,0.47917 1.4375,0.32291 1.60417,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 451.68229,392.31771 1.59896,-0.15625 1.4375,-0.32291 1.44271,-0.47917 1.4375,-0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path147"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 457.76042,390.71875 2.07812,-1.4375 1.92188,-1.59895 1.59895,-1.92188 1.44271,-1.92187",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 464.80208,383.83855 1.4375,-2.40105 1.28125,-2.55729 1.11979,-2.5625 0.79688,-2.71875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path149"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.28125,373.59896 0.79687,-3.52083 0.64063,-3.35938 0.32292,-3.52083 0.15625,-3.51562",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 471.19792,359.6823 -0.15625,-3.52084 -0.32292,-3.52083 -0.64063,-3.35938 -0.79687,-3.52083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path151"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.4375,345.76042 -0.79688,-2.71875 -1.11979,-2.5625 -1.28125,-2.55729 -1.4375,-2.40104",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 464.80208,335.52084 -0.64062,-0.95834 -0.80209,-1.125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path153"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 427.68229,326.88021 0.15625,1.11979 0.47917,1.1198 0.64062,0.95833 0.96354,0.64062 1.1198,0.47917 1.11979,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 427.52083,326.88021 V 313.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path155"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 432.16146,309.4375 -1.11979,0.16146 -1.1198,0.47917 -0.96354,0.64062 -0.64062,0.96355 -0.47917,1.11979 -0.15625,1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 432.16146,309.28125 h 39.19791",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path157"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 475.83854,313.92188 -0.15625,-1.11979 -0.48437,-1.11979 -0.63542,-0.96355 -0.96354,-0.64062 -1.11979,-0.47917 -1.1198,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 476,313.92188 v 12.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path159"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 471.35937,331.35938 1.1198,-0.16146 1.11979,-0.47917 0.96354,-0.64062 0.63542,-0.95833 0.48437,-1.1198 0.15625,-1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 471.35937,331.52084 H 432.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path161"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 471.35937,333.28125 h 0.80209 l 0.95833,-0.16145 0.80208,-0.31771 0.79688,-0.48438",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path162"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 471.35937,333.4375 H 432.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path163"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 428.80208,332.31771 0.79688,0.48438 0.80208,0.31771 0.95833,0.16145 h 0.80209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00165767,0.00186733 -1.118134,-1.440841 l -1.442708,-1.4375 -1.4375,-1.119792 -1.760417,-0.963541 -1.760417,-0.640625 -1.921875,-0.317709 -1.916666,-0.161458 -1.921875,0.161458 -1.921875,0.317709 -1.760417,0.640625 -1.760417,0.963541 -1.4375,1.119792 -1.442708,1.4375 -1.119792,1.44270833",
    transform: "matrix(0.75,0,0,0.75,347.28001,289.44001)",
    id: "path165"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.002502,-8.39e-4 0.158956,0.801244 0.638123,1.598119 1.440206,2.082494 2.24229,2.238744 3.039165,2.082494 3.841248,1.598119 4.320415,0.801244 4.481873,-8.39e-4 4.320415,-0.797714 3.841248,-1.599797 3.039165,-2.078964 2.24229,-2.240422 1.440206,-2.078964 0.638123,-1.599797 0.158956,-0.797714 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,337.08,240.36)",
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,-0.00249667 1.598114,-0.158747 l 1.442708,-0.640625 1.28125,-0.802083 0.958334,-1.119792 0.640625,-1.4375 0.479166,-1.442708 v -1.598958 l -0.479166,-1.4375 -0.640625,-1.442709 -0.958334,-1.119791 -1.28125,-0.802084 -1.442708,-0.635416 -1.598958333,-0.161459 -1.598958667,0.161459 -1.442708,0.635416 -1.276042,0.802084 -0.963541,1.119791 -0.635417,1.442709 -0.484375,1.4375 v 1.598958 l 0.484375,1.442708 0.635417,1.4375 0.963541,1.119792 1.276042,0.802083 1.442708,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,360.36001,346.08)",
    id: "path167"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 485.11979,459.6823 -9.28125,-9.1198 m 0,9.1198 9.28125,-9.1198",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00101767,4.12e-4 V 0.16187 L -0.160441,0.31812 v 0.161459 h -0.161458 v 0.479166 h -0.15625 v 0.322917 h 0.15625 v 0.15625 h -0.15625 l 0.15625,0.161458 v 0.322917 h 0.161458 v 0.15625 L 0.00101767,2.239995 H 0.162476 v 0.317709 h 0.317708 v 0.161458 h 1.28125 V 2.557704 H 2.079143 V 2.401454 H 2.240601 V 2.239995 H 2.402059 V 2.078537 l 0.15625,-0.15625 V 1.760829 L 2.719768,1.59937 V 0.641037",
    transform: "matrix(0.75,0,0,0.75,403.80002,403.32)",
    id: "path169"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 541.11979,538.40105 h 0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,0.001023 H -0.161662 v -0.322917 h -0.15625 v -0.15625 H -0.47937 V -0.639602 H -0.640828 V -0.80106 h -0.161459 v -0.161459 h -0.635416 v -0.15625 h -0.161459 v 0.15625 h -0.640625 v 0.161459 h -0.161458 v 0.161458 h -0.317708",
    transform: "matrix(0.75,0,0,0.75,405.84,403.80001)",
    id: "path171"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,6.15333e-4 V 0.162074 6.15333e-4 H -0.481262 V -0.160843 h -0.15625 V -0.322301 H -0.79897 v -0.15625 h -0.161459 v -0.322917 h -0.161458 v -0.479167 h -0.15625 v -0.161458 l 0.15625,-0.15625 -0.15625,-0.161458 h 0.15625 v -0.479167 h 0.161458 v -0.161458 l 0.161459,-0.161459 h 0.161458 v -0.15625 h 0.15625 v -0.161458 h 0.161458 v -0.161458 h 1.28125 v 0.161458 h 0.317709 v 0.161458 h 0.161458 v 0.15625 h 0.161458 v 0.322917 h 0.15625 V -1.92126 H 1.91978",
    transform: "matrix(0.75,0,0,0.75,404.40001,399.48001)",
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 541.11979,530.71875 h 0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,-0.00121567 V 0.962326 L -0.161662,1.118576 v 0.161458 h -0.15625 V 1.441493 L -0.47937,1.597743 H -0.640828 V 1.759201 H -0.802287 V 1.920659 H -1.119995 V 2.082118 H -1.281453 V 1.920659 h -0.15625 V 2.082118 H -1.599162 L -1.76062,1.920659 h -0.161458",
    transform: "matrix(0.75,0,0,0.75,405.84,398.03997)",
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.002502,0.00189733 -0.32021,-2.878311 l -0.479167,-2.723958 -0.640625,-2.880209 -0.958333,-2.71875 -1.28125,-2.557291 -1.442709,-2.5625 -1.598958,-2.239584 -1.916667,-2.239583",
    transform: "matrix(0.75,0,0,0.75,403.08,400.43998)",
    id: "path175"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,-1.98e-4 -1.117696,-0.958531 -2.237488,-1.760615 -3.680196,-2.40124 l -1.28125,-0.317708 -1.4375,-0.161458 h -1.442709 l -1.4375,0.322916 -1.28125,0.479167",
    transform: "matrix(0.75,0,0,0.75,396.59999,384.83999)",
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.001892,0.001663 -1.916667,1.119792 -1.760416,1.4375 -1.598959,1.442708 -1.28125,1.916667 -0.958333,1.921875 -0.802083,2.078125 -0.479167,2.083333 -0.161458,2.239583",
    transform: "matrix(0.75,0,0,0.75,388.56001,383.28)",
    id: "path177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 509.11979,525.28125 v 19.52084",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,0.00210067 0.161255,2.241684 l 0.479167,2.078125 0.802083,2.078125 0.958333,1.921875 1.28125,1.921875 1.598959,1.4375 1.760416,1.442708 1.916667,1.119792",
    transform: "matrix(0.75,0,0,0.75,381.84,408.59999)",
    id: "path179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,0.001694 1.280843,0.480861 l 1.4375,0.317708 h 1.442709 l 1.4375,-0.15625 1.28125,-0.322917 1.442708,-0.640625 1.119792,-0.796875 1.119791,-0.963541",
    transform: "matrix(0.75,0,0,0.75,388.67999,419.27998)",
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,-0.00168333 1.918762,-2.241267 3.51772,-4.48085 l 1.442709,-2.557292 1.28125,-2.5625 0.958333,-2.71875 0.640625,-2.880208 0.479167,-2.71875 0.317708,-2.880208",
    transform: "matrix(0.75,0,0,0.75,396.59999,417.72001)",
    id: "path181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 505.28125,544.80209 V 525.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,4.12e-4 -2.560405,0.16187 l -2.557291,0.479167 -2.401042,0.796875 -2.239583,1.119792 -2.083334,1.442708 -1.916666,1.760417 -1.760417,1.916666 -1.442708,2.083334 -1.119792,2.239583 -0.796875,2.401042 -0.484375,2.557291 -0.15625,2.5625",
    transform: "matrix(0.75,0,0,0.75,393.59999,379.32)",
    id: "path183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 524.80208,505.59896 h 17.11979 l 2.5573,2.5625 v 53.76042 l -2.5573,2.55729 h -17.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.001251,0.00210067 0.15625,2.55729133 0.484375,2.5625 0.796875,2.395834 1.119792,2.244791 1.442708,2.078125 1.760417,1.921875 1.916666,1.755209 2.083334,1.442708 2.239583,1.119792 2.401042,0.802083 2.557291,0.479167 2.5625,0.15625",
    transform: "matrix(0.75,0,0,0.75,378.96,408.59999)",
    id: "path185"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-0.00229333 H 0.482076 L 0.961243,-0.320002 1.278951,-0.63771 1.44041,-1.122085 V -1.757502 L 1.117493,-2.080418 0.638326,-2.398127 0.15916,-2.559585",
    transform: "matrix(0.75,0,0,0.75,405.24,402.24)",
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 540.47917,533.76042 h -0.31771 l -7.35938,0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path187"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 532.80208,534.40105 -0.16146,0.3177 -0.16145,0.32292 0.16145,0.31771 0.16146,0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 540.47917,536.31771 -7.67709,-0.63541 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 532.80208,534.40105 -0.16146,0.16145 -0.16145,0.15625 v 0.64063 l 0.32291,0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00148533,8.18667e-4 -1.118306,0.162277 -2.081848,0.641444 -2.878723,1.438319 -3.35789,2.40186 -3.519348,3.521652 -3.35789,4.641444 -2.878723,5.599777 -2.081848,6.40186 -1.118306,6.881027 0.00148533,7.042485 1.121277,6.881027 2.07961,6.40186 2.881694,5.599777 3.36086,4.641444 3.522319,3.521652 3.36086,2.40186 2.881694,1.438319 2.07961,0.641444 1.121277,0.162277 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,396.11998,398.64001)",
    id: "path191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-0.00229333 H 0.482076 L 0.961243,-0.320002 1.278951,-0.799168 1.44041,-1.278335 1.278951,-1.757502 0.961243,-2.241877 0.482076,-2.559585 h -0.48437467",
    transform: "matrix(0.75,0,0,0.75,405.24,402.24)",
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 404.39844,402.23828 h 0.12109 v 0.12109 z m 0,0",
    id: "path193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 404.39844,400.44141 0.12109,-0.24219 v 0.12109 z m 0,0",
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 404.51953,400.32031 0.24219,-0.24219 v 0.24219 z m 0,0",
    id: "path195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 404.51953,400.32031 v -0.12109 l 0.24219,-0.1211 z m 0,0",
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 404.51953,402.35937 0.24219,-0.12109 v 0.24219 z m 0,0",
    id: "path197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 404.51953,402.35937 v -0.12109 h 0.24219 z m 0,0",
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 404.76172,400.32031 405,400.07812 v 0.24219 z m 0,0",
    id: "path199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 404.76172,400.32031 v -0.24219 H 405 Z m 0,0",
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 404.76172,402.48047 405,402.23828 v 0.36328 z m 0,0",
    id: "path201"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 404.76172,402.48047 v -0.24219 H 405 Z m 0,0",
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405,400.32031 0.12109,-0.35937 v 0.35937 z m 0,0",
    id: "path203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405,400.32031 v -0.24219 l 0.12109,-0.11718 z m 0,0",
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405,402.60156 0.12109,-0.36328 v 0.36328 z m 0,0",
    id: "path205"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405,402.60156 v -0.36328 h 0.12109 z m 0,0",
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.12109,400.32031 0.23828,-0.35937 v 0.35937 z m 0,0",
    id: "path207"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.12109,400.32031 v -0.35937 h 0.23828 z m 0,0",
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.12109,402.60156 0.23828,-0.36328 v 0.36328 z m 0,0",
    id: "path209"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.12109,402.60156 v -0.36328 h 0.23828 z m 0,0",
    id: "path210"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.35937,400.32031 0.1211,-0.35937 v 0.35937 z m 0,0",
    id: "path211"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.35937,400.32031 v -0.35937 h 0.1211 z m 0,0",
    id: "path212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.35937,402.60156 0.1211,-0.36328 v 0.36328 z m 0,0",
    id: "path213"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.35937,402.60156 v -0.36328 h 0.1211 z m 0,0",
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.48047,400.32031 0.12109,-0.35937 v 0.35937 z m 0,0",
    id: "path215"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.48047,400.32031 v -0.35937 h 0.12109 z m 0,0",
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.48047,402.60156 0.12109,-0.36328 v 0.36328 z m 0,0",
    id: "path217"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.48047,402.60156 v -0.36328 h 0.12109 z m 0,0",
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.60156,402.60156 0.11719,-0.36328 v 0.36328 z m 0,0",
    id: "path219"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.60156,402.60156 v -0.36328 h 0.11719 z m 0,0",
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.60156,400.32031 0.23828,-0.24219 v 0.36329 z m 0,0",
    id: "path221"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.60156,400.32031 v -0.35937 l 0.23828,0.11718 z m 0,0",
    id: "path222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.71875,402.60156 0.12109,-0.48047 v 0.35938 z m 0,0",
    id: "path223"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.71875,402.60156 v -0.36328 l 0.12109,-0.11719 z m 0,0",
    id: "path224"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.83984,400.44141 0.1211,-0.24219 v 0.35937 z m 0,0",
    id: "path225"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.83984,400.44141 v -0.36329 l 0.1211,0.1211 z m 0,0",
    id: "path226"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 405.83984,402.48047 405.96094,402 v 0.35937 z m 0,0",
    id: "path227"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.83984,402.48047 v -0.35938 L 405.96094,402 Z m 0,0",
    id: "path228"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.96094,400.55859 0.11718,-0.35937 v 0.48047 z m 0,0",
    id: "path229"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.96094,400.55859 v -0.35937 h 0.11718 z m 0,0",
    id: "path230"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 405.96094,402.35937 0.11718,-0.48046 v 0.48046 z m 0,0",
    id: "path231"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 405.96094,402.35937 V 402 l 0.11718,-0.12109 z m 0,0",
    id: "path232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.07812,402.35937 0.1211,-0.48046 v 0.48046 z m 0,0",
    id: "path233"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.07812,402.35937 v -0.48046 h 0.1211 z m 0,0",
    id: "path234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.07812,400.67969 0.1211,-0.35938 v 0.48047 z m 0,0",
    id: "path235"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.07812,400.67969 v -0.48047 l 0.1211,0.12109 z m 0,0",
    id: "path236"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.19922,402.23828 0.12109,-0.71875 v 0.60156 z m 0,0",
    id: "path237"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.19922,402.23828 v -0.59766 l 0.12109,-0.12109 z m 0,0",
    id: "path238"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.19922,400.92187 0.12109,-0.48046 v 0.71875 z m 0,0",
    id: "path239"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.19922,400.92187 v -0.60156 l 0.12109,0.1211 z m 0,0",
    id: "path240"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.32031,401.28125 0.1211,-0.72266 v 0.72266 z m 0,0",
    id: "path241"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.32031,401.28125 v -0.83984 l 0.1211,0.11718 z m 0,0",
    id: "path242"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.32031,402.12109 0.1211,-0.83984 V 402 Z m 0,0",
    id: "path243"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.32031,402.12109 v -0.83984 h 0.1211 z m 0,0",
    id: "path244"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.44141,401.28125 0.11718,-0.35938 v 0.35938 z m 0,0",
    id: "path245"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.44141,401.28125 v -0.60156 l 0.11718,0.24218 z m 0,0",
    id: "path246"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.44141,401.87891 0.11718,-0.59766 v 0.35937 z m 0,0",
    id: "path247"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.44141,401.87891 v -0.59766 h 0.11718 z m 0,0",
    id: "path248"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.55859,401.51953 v -0.23828 h 0.1211 z m 0,0",
    id: "path249"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 406.55859,401.28125 v -0.24219 l 0.1211,0.24219 z m 0,0",
    id: "path250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 540.47917,533.76042 -7.67709,0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 335.83854,485.1198 v 157.11979 h -9.91667 V 485.1198 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,0.00125633 -0.638326,-0.800827 l -0.963542,-0.796875 -0.958333,-0.484375 -1.119792,-0.317708 -1.119792,-0.161459 -1.119791,0.161459 -1.119792,0.317708 -0.958333,0.484375 -0.963542,0.796875 -0.640625,0.80208333",
    transform: "matrix(0.75,0,0,0.75,251.75999,363.95999)",
    id: "path253"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001862,-0.00188667 0.638763,0.800197 1.602305,1.60228 2.560638,2.081447 3.68043,2.399155 4.800221,2.560613 5.920013,2.399155 7.039805,2.081447 7.998138,1.60228 8.96168,0.800197 9.602305,-0.00188667",
    transform: "matrix(0.75,0,0,0.75,244.55999,481.56001)",
    id: "path254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 330.88021,485.1198 V 642.23959",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path255"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g255"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 253.91615,
    y: 400.55859,
    id: "use255"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 12456.637,-7921.9279 c 8.649,3.8438 12.973,13.2131 12.973,27.8675 0,4.2042 -0.48,8.1681 -1.441,12.0119 l -5.285,21.1408 c -6.487,23.4231 -18.979,39.1586 -37.477,47.0864 -9.009,3.8438 -19.58,5.7657 -31.712,5.7657 h -40.84 c -7.087,0 -10.57,-3.4835 -10.57,-10.5704 0,-6.9669 3.483,-10.5705 10.57,-10.5705 h 46.606 c 8.889,0 17.417,-3.0029 25.465,-9.129 8.288,-6.0059 13.574,-13.5733 15.856,-22.5822 l 5.765,-21.1408 c 0.961,-4.0841 1.442,-8.1681 1.442,-12.0119 0,-13.0929 -8.649,-19.6994 -25.946,-19.6994 h -19.219 c -7.087,0 -10.57,-3.4834 -10.57,-10.5704 0,-6.9669 3.483,-10.5704 10.57,-10.5704 h 24.985 c 12.733,0 23.663,-5.045 32.672,-15.3752 4.084,-4.8047 6.967,-10.0899 8.649,-15.8556 0.6,-3.8438 0.961,-6.9669 0.961,-9.6095 0,-14.6544 -8.529,-22.1018 -25.465,-22.1018 h -40.841 c -7.087,0 -10.57,-3.4834 -10.57,-10.5704 0,-6.9669 3.483,-10.5704 10.57,-10.5704 h 46.606 c 16.336,0 28.468,7.4473 36.516,22.1018 3.484,6.4864 5.285,13.3331 5.285,20.6603 0,3.2432 -0.48,6.6065 -1.441,10.09 -6.126,22.8225 -17.537,37.4769 -34.114,44.2035 z m 0,0",
    transform: "matrix(0,0.03252,-0.03252,0,0,-4e-6)",
    id: "path256"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g256"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 253.91615,
    y: 405.45453,
    id: "use256"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 12549.489,-7829.1965 c 22.102,0 36.035,-10.5704 41.801,-31.7112 l 5.766,-21.1408 c 0.961,-4.0841 1.441,-7.9279 1.441,-11.5314 0,-13.4533 -8.648,-20.1799 -25.945,-20.1799 h -33.153 l -13.934,52.8521 c -0.961,3.2432 -1.441,5.7657 -1.441,7.6876 0,7.4473 2.402,13.3331 7.207,17.7775 5.045,4.2041 11.171,6.2461 18.258,6.2461 z m -5.285,21.1409 c -15.135,0 -26.907,-7.6876 -35.555,-23.0627 -3.844,-6.9669 -5.766,-14.0539 -5.766,-21.1409 0,-2.8828 0.24,-5.5254 0.961,-8.168 l 16.816,-63.903 c 6.367,-23.303 16.937,-42.8823 31.712,-58.6178 16.576,-17.5373 38.077,-29.5491 64.383,-36.0355 0.961,0 1.922,0 2.883,0 6.967,0 10.57,3.6035 10.57,10.5704 0,5.7657 -2.402,9.0089 -7.207,9.6095 -11.531,1.6816 -23.303,6.126 -35.074,13.4532 -21.501,13.2131 -35.315,30.0296 -41.321,50.4498 h 31.711 c 12.132,0 22.102,3.8438 29.79,11.5313 7.927,7.6876 12.012,17.6574 12.012,29.7894 0,4.2041 -0.481,8.0479 -1.442,11.5314 l -5.766,21.1408 c -6.726,24.7444 -18.618,40.6 -35.555,47.5669 -9.009,3.6035 -20.059,5.2852 -33.152,5.2852 z m 0,0",
    transform: "matrix(0,0.03252,-0.03252,0,0,-4e-6)",
    id: "path257"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g257"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 253.91615,
    y: 410.35049,
    id: "use257"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 12767.384,-7912.3184 -60.54,99.458 c -2.282,3.2432 -5.285,4.8048 -9.129,4.8048 -2.883,0 -5.525,-1.0811 -7.688,-3.3633 -1.921,-2.1622 -2.882,-4.8048 -2.882,-7.6876 l 7.207,-189.7871 c 0,-6.7266 3.483,-10.0899 10.57,-10.0899 7.327,0 10.811,3.7237 10.571,11.0509 l -6.247,149.9077 57.177,-92.7314 c 1.922,-3.4834 4.804,-5.2852 8.648,-5.2852 6.727,0 10.33,3.3633 11.051,10.09 l 6.727,89.3681 77.356,-156.6344 c 1.922,-3.8438 5.045,-5.7657 9.609,-5.7657 6.967,0 10.571,3.3633 10.571,10.0899 0,1.9219 -0.36,3.6036 -0.961,4.8048 l -94.653,190.2675 c -1.922,3.8438 -5.045,5.7657 -9.129,5.7657 -6.727,0 -10.451,-3.1231 -11.051,-9.6095 z m 0,0",
    transform: "matrix(0,0.03252,-0.03252,0,0,-4e-6)",
    id: "path258"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g258"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 254.03584,
    y: 424.55511,
    id: "use258"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 13178.189,-7832.8 c 6.966,0 10.57,3.6035 10.57,10.5704 0,7.087 -3.604,10.5704 -10.57,10.5704 h -90.329 c -2.883,0 -5.166,-0.9609 -6.727,-2.8828 -1.682,-2.1621 -2.162,-4.8047 -1.442,-7.6876 l 51.892,-192.6699 c 1.201,-5.045 4.564,-7.6876 10.09,-7.6876 6.966,0 10.57,3.3634 10.57,10.09 0,1.3213 -0.24,2.4024 -0.48,3.3633 l -47.087,176.3338 z m 0,0",
    transform: "matrix(0,0.03252,-0.03252,0,0,-4e-6)",
    id: "path259"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g259"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 254.03584,
    y: 429.45105,
    id: "use259"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 13335.424,-7917.3634 h -57.657 l -22.583,84.5634 h 73.513 c 6.967,0 10.57,3.6035 10.57,10.5704 0,7.087 -3.603,10.5704 -10.57,10.5704 h -90.329 c -2.883,0 -5.165,-0.9609 -6.727,-2.8828 -1.681,-2.1621 -2.162,-4.8047 -1.441,-7.6876 l 50.93,-189.787 c 1.922,-6.9669 6.486,-10.5705 13.934,-10.5705 h 84.563 c 6.967,0 10.571,3.6036 10.571,10.5705 0,7.0869 -3.604,10.5704 -10.571,10.5704 h -79.278 l -16.817,62.942 h 51.892 c 6.966,0 10.57,3.6036 10.57,10.5704 0,7.087 -3.604,10.5704 -10.57,10.5704 z m 0,0",
    transform: "matrix(0,0.03252,-0.03252,0,0,-4e-6)",
    id: "path260"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g260"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 254.03584,
    y: 434.25101,
    id: "use260"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 13428.756,-8012.0166 c 1.921,-6.9669 6.486,-10.5705 13.933,-10.5705 h 65.825 c 10.811,0 20.42,4.6847 28.829,13.9338 8.288,9.3692 12.492,19.4592 12.492,30.2698 0,2.8828 -0.361,5.7657 -0.961,8.6485 l -28.348,105.2237 c -9.61,35.3148 -32.552,52.8521 -68.708,52.8521 h -65.825 c -2.882,0 -5.165,-0.9609 -6.726,-2.8828 -1.682,-2.1621 -2.162,-4.8047 -1.442,-7.6876 z m 19.218,10.5704 -45.164,168.6462 h 54.293 c 9.25,0 17.898,-3.003 25.946,-9.129 7.928,-6.0059 13.213,-13.5734 15.856,-22.5823 l 27.867,-105.2237 c 0.961,-2.8828 1.442,-5.5254 1.442,-8.168 0,-6.9669 -2.643,-12.6125 -7.688,-16.8166 -4.805,-4.4444 -10.811,-6.7266 -17.778,-6.7266 z m 0,0",
    transform: "matrix(0,0.03252,-0.03252,0,0,-4e-6)",
    id: "path261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 348.31771,566.23959 v 23.52083 h -10.07813 v -23.52083 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 533.76042,378.88021 1.11979,-0.16146 1.11979,-0.47916 0.95833,-0.64063 0.64063,-0.95833 0.47916,-1.11979 0.16146,-1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 533.76042,379.04167 H 506.23958",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 501.76042,374.40105 0.16145,1.11979 0.47917,1.11979 0.64063,0.95833 0.95833,0.64063 1.11979,0.47916 1.11979,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 501.76042,374.40105 V 312.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 506.23958,308.47917 -1.11979,0.16146 -1.11979,0.47917 -0.95833,0.64062 -0.64063,0.95833 -0.47917,1.1198 -0.16145,1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 506.23958,308.31771 h 27.52084",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 538.23958,312.95834 -0.16146,-1.11979 -0.47916,-1.1198 -0.64063,-0.95833 L 536,309.1198 l -1.11979,-0.47917 -1.11979,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 538.40104,312.95834 v 61.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path270"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g270"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-0",
    x: 384.96619,
    y: 249.72263,
    id: "use270"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g271"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 384.96619,
    y: 255.83789,
    id: "use271"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g272"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-2",
    x: 384.96619,
    y: 261.95312,
    id: "use272"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/План_житловий універсальний.caae8002301dcf5b68331a977edbbd1d.svg";
export { ForwardRef as ReactComponent };